export default __webpack_public_path__ + "assets/05d646f7744e800f5eec72ea7eb51c47.png";